import { render, staticRenderFns } from "./OrganismSiteCreateEdit.vue?vue&type=template&id=2fef3a90&scoped=true&"
import script from "./OrganismSiteCreateEdit.vue?vue&type=script&lang=js&"
export * from "./OrganismSiteCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrganismSiteCreateEdit.vue?vue&type=style&index=0&id=2fef3a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fef3a90",
  null
  
)

export default component.exports